import { useEffect, useState } from "react";

const Lists = ({ integrationData, lists, listId, setListId }) => {
  const [loading, setLoading] = useState(false);

  return (
    <div className="flex flex-col gap-4 sm:px-4 md:px-20 h-[400px] overflow-y-scroll">
      <p>
        Select a list from the connected Zoho account to which new subscribers
        will be added.
      </p>
      <div className="flex flex-col gap-2">
        <label className="text-semibold text-gray-700">List Name</label>
        {loading ? (
          <div className="w-full h-8 rounded-lg bg-gray-200 animate-pulse"></div>
        ) : lists?.length > 0 ? (
          <select
            className="border-gray-200 rounded-md text-sm text-gray-500"
            value={listId}
            onChange={(e) => setListId(e.target.value)}
          >
            <option value="">Select a list</option>
            {lists?.map((list) => (
              <option key={list.listkey} value={list.listkey} className="">
                {list?.listname}
              </option>
            ))}
          </select>
        ) : (
          <p className="text-gray-500 text-sm">No lists found</p>
        )}
      </div>
    </div>
  );
};

export default Lists;
